import { Create } from "react-admin"
import FormInput from "./FormInput"
import InfoTotalInvoiceCount from "./InfoTotalInvoiceCount"

const InvoiceCreate = () => {

  return (
    <>
      <InfoTotalInvoiceCount />
      <Create>
        <FormInput 
          resource="invoices" 
        />
      </Create>
    </>
  )
}

export default InvoiceCreate